import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SettingsService {

  public user: any;
  public almacen: any;
  public app: any;

    constructor() {

        this.user = {
            name: 'empty',
            id: 'empty',
            email: 'empty'
        };

        // App Settings
        // -----------------------------------
        this.almacen = {
            name: 'empty',
            description: 'empty',
        };

        this.app = {
            name: ' AB Servicios Selecta España, S.L.U - All rights reserved',
            description: '',
            year: ((new Date()).getFullYear()),
            version: 'V 2.1.0',
            cierre: 'yyyy-mm-dd',
            cliente: ''
        };

    }

   
    getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    
    setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }

    getAlmacenSetting(name) {
        return name ? this.user[name] : this.user;
    }
    
    setAlmacenSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    
    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }


}
